<template>
  <div class="loader red-hat-medium">
      <div class="loader-div">
        <div class="main-loader-div">
          <img src="@/assets/Loader2.svg" class="loader-image" alt="loader" />
        </div>
        <p class="loading"> Please wait a moment</p>
      </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
  .loader {
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.5);
  }
  .loader-div {
    width: 16%;
    background-color: #ffffff;
    margin: 18% 42%;
    padding: 16px;
    border-radius: 16px;
  }
  .main-loader-div {
    margin: auto;
    text-align: center;
  }
  p {
    color: #000000;
    font-size: 0.8rem;
    text-align: center;
  }
  /* loading dots */
  .loading:after {
    content: ' .';
    animation: dots 1s steps(5, end) infinite;}

  @keyframes dots {
    0%, 20% {
      color: #000000;
      text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0);
    }
    40% {
      color: #000000;
      text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0);
    }
    60% {
      text-shadow: .25em 0 0 #000000, .5em 0 0 rgba(0,0,0,0);}
    80%, 100% {
      text-shadow: .25em 0 0 #000000, .5em 0 0 #000000;
    }
  }
  @media only screen and (max-width: 767px) {
    .loader-div {
      width: 30%;
      margin: 60% auto;
    }
  }
  @media only screen and (min-width: 1800px) {
    .loader-div {
      width: 12%;
      margin: 24% 44%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/Loader.vue